import React from "react";

const Spinner = () => <div
  className="spinner-border"
  style={{width: 100, height: 100}}
  role="status"
/>;

export default Spinner;